export const version = '0.768.0'
export const chameleonWebVersion = '9.0.1'
export const chameleonCoreVersion = '7.6.0'
